import React from 'react';
import { Helmet } from 'react-helmet-async';
import { getAbsoluteUrl, getOgImageUrl, DEFAULT_OG_IMAGE_PATH } from '../config/urls';

const MetaTags = ({ 
  title = 'FLARETECH 採用サイト', 
  description = 'FLARETECHの採用情報サイト。UI/UXデザイナー、エンジニア、プロダクトマネージャーなど、様々な職種で一緒に働く仲間を募集しています。',
  keywords = 'FLARETECH,採用,デザイナー,エンジニア,UI/UX,プロダクトマネージャー',
  ogImage = DEFAULT_OG_IMAGE_PATH,
  path = ''
}) => {
  const fullUrl = getAbsoluteUrl(path);
  const ogImageUrl = getOgImageUrl(ogImage);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="FLARETECH ロゴ" />
      <meta property="og:site_name" content="FLARETECH 採用サイト" />
      <meta property="og:locale" content="ja_JP" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImageUrl} />
      
      {/* Additional SEO */}
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};

export default MetaTags;
